import { Directive, HostBinding, inject, Input, OnDestroy, OnInit } from '@angular/core';

import { KH_A11Y_TARGET } from '../constants/a11y-target.token';
import { createA11yId, normalizeAriaValue } from '../utils/a11y.util';

@Directive({
  selector: '[khA11yDescriptionSource]',
  exportAs: 'khA11yDescriptionSource'
})
export class A11yDescriptionSourceDirective implements OnInit, OnDestroy {
  private readonly generatedId = createA11yId('kh-a11y-description');
  private readonly target = inject(KH_A11Y_TARGET, { optional: true });

  @Input('khA11yDescriptionSource') public descriptionId: string | null = null;

  @HostBinding('attr.id')
  public get id(): string {
    return normalizeAriaValue(this.descriptionId) ?? this.generatedId;
  }

  public ngOnInit(): void {
    this.target?.registerDescription(this.id);
  }

  public ngOnDestroy(): void {
    this.target?.unregisterDescription(this.id);
  }
}
